import { Text, Box, Group, Badge } from "@mantine/core";
import { ProcessStep } from "../../services/logService";

export function SlipResolutionContent({ log }: { log: ProcessStep }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = (log.details as any) || {};
  const detectedType = details.detectedSlipType;
  const resolvedType = details.resolvedTypeName;
  const matchMethod = details.matchMethod; // "exact" | "alias" | "ai" | "none"
  const aiRawResponse = details.aiRawResponse;

  const methodLabels: Record<string, { label: string; color: string }> = {
    exact: { label: "完全一致", color: "green" },
    alias: { label: "エイリアス", color: "blue" },
    ai: { label: "AI名寄せ", color: "violet" },
    none: { label: "該当なし", color: "red" },
  };
  const method = methodLabels[matchMethod] || { label: matchMethod, color: "gray" };

  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>

      <Box
        mt="xs"
        p="xs"
        bg="var(--mantine-color-default)"
        style={{
          borderRadius: "6px",
          border: "1px solid var(--mantine-color-default-border)",
        }}
      >
        <Group align="center" gap="sm">
          {detectedType && (
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                検出
              </Text>
              <Text size="xs" fw={600}>
                {detectedType}
              </Text>
            </Box>
          )}
          <Text size="xs" c="dimmed">
            →
          </Text>
          {resolvedType ? (
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                解決
              </Text>
              <Text size="xs" fw={700} c={`var(--mantine-color-${method.color}-6)`}>
                {resolvedType}
              </Text>
            </Box>
          ) : (
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="xs" c="red" fw={600}>
                該当なし
              </Text>
            </Box>
          )}
          <Badge size="xs" variant="light" color={method.color}>
            {method.label}
          </Badge>
        </Group>

        {aiRawResponse && (
          <Box mt="xs">
            <Text size="10px" c="dimmed">
              AI応答
            </Text>
            <Text size="xs" c="dimmed" fs="italic">
              {aiRawResponse}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
